<template>
  <div
    v-if="isExistSoftVersion"
    data-qa="soft_version_icon"
    class="d-inline-flex"
    :style="{ verticalAlign: 'middle' }"
  >
    <SoftVersionImage
      ref="tooltipTrigger"
      :image="softData.image"
    />
    <div
      ref="tooltipContent"
      class="d-none"
    >
      <div class="text-subtitle-1 mb-1">
        {{ $t('Подключена версия', { ns: $i18next.language }) }} {{ softData.translate }}
      </div>
      <ul class="text-body-1 pl-6">
        <li
          v-for="(benefit, i) in listBenefits"
          :key="i"
        >
          {{ $t(`${benefit}`, { ns: $i18next.language }) }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Hint from 'www/modules/Hint'
import SoftVersionImage from 'www/vue_components/common/SoftVersionIcon/components/common/SoftVersionImage.vue'
import { SoftVersionGlobalData } from 'www/vue_components/common/SoftVersionIcon/mixins'

export default {
  name: 'SoftVersionIcon',
  components: {
    SoftVersionImage,
  },
  mixins: [
    SoftVersionGlobalData,
  ],
  mounted() {
    if (!this.isExistSoftVersion) {
      return
    }

    const tooltipContent = this.$refs.tooltipContent.cloneNode(true)

    tooltipContent.classList.remove('d-none')
    this.$refs.tooltipContent.remove()

    new Hint({
      isMobile: false,
      templateLinking: () => tooltipContent,
      target: this.$refs.tooltipTrigger.$el,
      tippyOptions: {
        trigger: 'mouseenter',
        maxWidth: '380px',
      },
    })
  },
}
</script>
